import { getHintUtils } from "@epic-web/client-hints";
import {
	clientHint as colorSchemeHint,
	subscribeToSchemeChange,
} from "@epic-web/client-hints/color-scheme";
import { clientHint as timeZoneHint } from "@epic-web/client-hints/time-zone";
import { useRouter } from "@tanstack/react-router";
import { createIsomorphicFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { useEffect } from "react";
import { useRequestInfo } from "./request-info.ts";

const hintsUtils = getHintUtils({
	theme: colorSchemeHint,
	timeZone: timeZoneHint,
});

export const getClientHints = createIsomorphicFn()
	.server(() => hintsUtils.getHints(getRequest()))
	.client(() => hintsUtils.getHints());

/**
 * @returns an object with the client hints and their values
 */
export function useHints() {
	const requestInfo = useRequestInfo();

	return requestInfo.hints;
}

export function useTimeZone() {
	const hints = useHints();

	return hints.timeZone;
}

/**
 * @returns inline script element that checks for client hints and sets cookies
 * if they are not set then reloads the page if any cookie was set to an
 * inaccurate value.
 */
export function ClientHintCheck() {
	const router = useRouter();

	useEffect(() => subscribeToSchemeChange(() => router.invalidate()), [router.invalidate]);

	return (
		<script
			// biome-ignore lint/security/noDangerouslySetInnerHtml: This script sets client hints cookies and reloads the page if needed.
			dangerouslySetInnerHTML={{
				__html: hintsUtils.getClientHintCheckScript(),
			}}
		/>
	);
}
